export default "__VITE_ASSET__c64c7fd3__"